<template>
  <div class="modal custom-modal fade" id="add_group" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Group</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="createContact">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="col-form-label">
                    Name
                    <span class="text-danger">*</span>
                  </label>
                  <input v-model="formCreateContact.name" class="form-control" type="text" required />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Description</label>
              <input v-model="formCreateContact.description" class="form-control" type="text" />
            </div>

            <div class="submit-section">
              <button :disabled="loading" class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },
  props: {
    getGroupList: Function,
  },
  data() {
    return {
      loading: false,
      formCreateContact: {
        name: "",
        description: ""
      },
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      }
    };
  },
  computed: {},
  methods: {
    async createContact() {
      this.loading = await true;
      await this.$store
        .dispatch("contact/createGroup", this.formCreateContact)
        .then(response => {
          this.formCreateContact = {
            name: "",
            description: ""
          };
          let params = { name: "", page: 0, perPage: 1000 };
          // this.$root.$emit("getGroupList", params);
          this.getGroupList()

          setTimeout(function () {
            var liContainer = document.getElementById("add_group");
            var isShowModal = liContainer.classList.contains("show");
          }, 1000);
          this.loading =  false;

          this.$fire({
            title: "Add Group",
            text: "Data added successfully",
            type: "success",
            timer: 2000
          }).then(r => { });
        });
      this.loading = await false;
    }
  },
  async created() { },
  mounted() { },
  name: "create-group"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/createGroup.vue